// Data.jsx

import { supabase } from '../../supabaseClient'; // Perbaiki path importnya


export const fetchStatus = async () => {
  const { data, error } = await supabase
    .from('statuses') // Nama tabel yang kamu buat di Supabase
    .select('status')
    .single(); // Mengambil satu baris saja

  if (error) {
    console.error(error);
    return null;
  }
  return data.status; // Mengembalikan status
};

export const contactInfo = {
  address: "Jalan Pleburan 45, Semarang Selatan, Kota Semarang Jawa Tengah",
  email: "qalvinahmad@gmail.com", 
  fiver: "@alvin_ahmad", 
  linkedin: "https://www.linkedin.com/in/alvin-ahmad-a137b1282/",
  status: ["open to work", "occupied", "offline"],  // Status yang default, akan diganti nanti
};
